import "./Header.scss";
import React, { Component, Fragment } from "react";
import { NavLink } from "react-router-dom";
import Brand from "../brand/Brand";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classnames from "classnames";
import {
    faFacebookF,
    faTwitter,
    faInstagram
} from "@fortawesome/free-brands-svg-icons";

class Header extends Component {
    constructor(props) {
        super(props);
        this.hamby = React.createRef();
        this.navbarList = React.createRef();

        this.state = {
            prevScrollpos: window.pageYOffset,
            visible: true
        };
    }

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleScroll = () => {
        const currentScrollPos = window.pageYOffset;

        if (this.navbarList.current && this.hamby.current) {
            this.navbarList.current.classList.remove("open");
            this.hamby.current.classList.remove("is-active");
        }

        let visible = true;
        if (currentScrollPos > 200) {
            visible = false;
        }

        this.setState({
            prevScrollpos: currentScrollPos,
            visible
        });
    };

    toggleMenu = () => {
        if (!this.hamby.current || !this.navbarList.current) return;

        if (this.hamby.current.classList.contains("is-active")) {
            this.navbarList.current.classList.remove("open");
            this.hamby.current.classList.remove("is-active");
        } else {
            this.navbarList.current.classList.add("open");
            this.hamby.current.classList.add("is-active");
        }
    };

    render() {
        return (
            <Fragment>
                <div
                    className={classnames("header_container", {
                        "header-container-hidden": !this.state.visible
                    })}
                    id="header_container"
                >
                    <header className="header">
                        {/* Left Social Icons */}
                        <div className="social-icons social-icons-nav-left hsn-desktop">
                            <ul className="social-icon-list">
                                <li>
                                    <a
                                        href="https://www.facebook.com/FATbastardWineSA"
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    >
                                        <FontAwesomeIcon icon={faFacebookF} />
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://www.instagram.com/fatbastardsa/"
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    >
                                        <FontAwesomeIcon icon={faInstagram} />
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://twitter.com/FATbastardSA"
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    >
                                        <FontAwesomeIcon icon={faTwitter} />
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <Brand color="light" />

                        <button
                            onClick={this.toggleMenu}
                            ref={this.hamby}
                            className="hamburger hamby hamburger--spin"
                            type="button"
                            id="hamby"
                        >
              <span className="hamburger-box">
                <span className="hamburger-inner" />
              </span>
                        </button>

                        {/* Right Cart Icon */}
                        <div className="social-icons social-icons-nav-right hsn-desktop">
                            <ul className="social-icon-list">
                                <li>
                                    <a href="https://shop.fatbastardwine.co.za/">
                                        <img
                                            src="/resources/img/Cart.png"
                                            alt=""
                                            width="20"
                                            height="20"
                                        />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </header>

                    <nav>
                        <ul
                            ref={this.navbarList}
                            className="navbar_list navbar_list_center"
                        >
                            <li>
                                <NavLink
                                    activeclassname="menu-selected"
                                    onClick={this.toggleMenu}
                                    to="/"
                                    exact
                                    className="nav-NavLink p-t-5 p-b-0"
                                >
                                    Home
                                </NavLink>
                            </li>

                            <li>
                                <NavLink
                                    activeclassname="menu-selected"
                                    onClick={this.toggleMenu}
                                    to="/the-fat-bastards"
                                    exact
                                    className="nav-NavLink p-t-5 p-b-0"
                                >
                                    The FAT <i style={{ lineHeight: 0 }}>bastards</i>
                                </NavLink>
                            </li>

                            <li>
                                <NavLink
                                    activeclassname="menu-selected"
                                    onClick={this.toggleMenu}
                                    to="/restaurants"
                                    exact
                                    className="nav-NavLink p-t-5 p-b-0"
                                >
                                    VIB
                                </NavLink>
                            </li>

                            <li>
                                <NavLink
                                    activeclassname="menu-selected"
                                    onClick={this.toggleMenu}
                                    to="/fat-inspirations"
                                    exact
                                    className="nav-NavLink p-t-5 p-b-0"
                                >
                                    FAT <i>Inspirations</i>
                                </NavLink>
                            </li>

                            <li>
                                <a
                                    href="https://shop.fatbastardwine.co.za/"
                                    className="nav-NavLink p-t-5 p-b-0"
                                    style={{ color: "#d6b052" }}
                                >
                                    Shop
                                </a>
                            </li>

                            {/* Get In Touch with Hover Submenu */}
                            <li className="nav-item-with-sub">
                                <NavLink
                                    activeclassname="menu-selected"
                                    onClick={this.toggleMenu}
                                    to="/contact-us"
                                    exact
                                    className="nav-NavLink p-t-5 p-b-0"
                                >
                                    Get In Touch
                                </NavLink>

                                <ul className="nav-submenu">
                                    <li>
                                        <NavLink
                                            activeclassname="menu-selected"
                                            onClick={this.toggleMenu}
                                            to="/sign-up"
                                            exact
                                            className="nav-NavLink nav-sub-link p-t-5 p-b-0"
                                        >
                                            Subscribe
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>

                            {/* Subscribe appears next to Get In Touch */}
                            <li>
                                <NavLink
                                    activeclassname="menu-selected"
                                    onClick={this.toggleMenu}
                                    to="/sign-up"
                                    exact
                                    className="nav-NavLink p-t-5 p-b-0"
                                >
                                    Subscribe
                                </NavLink>
                            </li>

                            {/* Mobile Social Icons */}
                            <li>
                                <div className="social-icons hsn-mobi">
                                    <ul className="social-icon-list">
                                        <li>
                                            <a
                                                href="https://www.facebook.com/FATbastardWineSA"
                                                rel="noopener noreferrer"
                                                target="_blank"
                                            >
                                                <FontAwesomeIcon icon={faFacebookF} />
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="https://twitter.com/FATbastardSA"
                                                rel="noopener noreferrer"
                                                target="_blank"
                                            >
                                                <FontAwesomeIcon icon={faTwitter} />
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.instagram.com/fatbastardsa/"
                                                rel="noopener noreferrer"
                                                target="_blank"
                                            >
                                                <FontAwesomeIcon icon={faInstagram} />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>
            </Fragment>
        );
    }
}

export default Header;
